module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/izabela-wadas-4cda7f2a367cf7a95a7c5c501626c74f.webp";